import candle from "../img/projects/candle.jpg";
import cat from "../img/projects/cat.jpg";
import bar from "../img/projects/bar.jpg";
import yacht from "../img/projects/yacht.jpg";
import pasta from "../img/projects/pasta.jpg";
import newyear from "../img/projects/newyear.jpg";
import weather from "../img/projects/weather.jpg";
import recipe from "../img/projects/recipe.jpg";
import shop from "../img/projects/shop.jpg";
import relax from "../img/projects/relax.jpg";
import tips from "../img/projects/tips.jpg";
import fact from "../img/projects/fact.jpg";
import indonesia from "../img/projects/indonesia.jpg";
import translation from "../img/projects/translation.jpg";
import movie from "../img/projects/movie.jpg";
import commerce from "../img/projects/commerce.jpg";
import travelblog from "../img/projects/travelblog.jpg";
import planets from "../img/projects/planets.jpg";

const projects = [
  {
    title: "Travel Blog",
    skills: "React, Vite, Node, MongoDB, API, HTML/CSS, Bootstrap",
    img: travelblog,
    link: "https://travel-blog-ca.netlify.app/",
  },
  {
    title: "Interactive planets",
    skills: "JavaScript, Three.js, Vite",
    img: planets,
    link: "https://planetsystem.netlify.app/",
  },
  {
    title: "Auction",
    skills: "JavaScript, Django, HTML/CSS, Bootstrap",
    img: commerce,
    link: "https://commerce-0b2s.onrender.com/",
  },
  {
    title: "Movies search",
    skills: "JavaScript, React, Node, API, HTML/CSS",
    img: movie,
    link: "https://lookformovies.netlify.app/",
  },
  {
    title: "Travel app",
    skills: "JavaScript, HTML/CSS",
    img: indonesia,
    link: "https://isexploreindonesia.netlify.app/",
  },
  {
    title: "Candles home shop",
    skills: "React, Redux, Node.js, MongoDB, Stripe",
    img: candle,
    link: "https://candelshome.netlify.app/",
  },

  {
    title: "Shop for cats",
    skills: "JavaScript, React, HTML, CSS",
    img: cat,
    link: "https://iridescent-smakager-627765.netlify.app/",
  },

  {
    title: "Irish bar",
    skills: "JavaScript, React, HTML, CSS",
    img: bar,
    link: "https://serene-chebakia-09cd1e.netlify.app/",
  },

  {
    title: "Marine surveys",
    skills: "JavaScript, HTML, CSS",
    img: yacht,
    link: "https://www.boatcv.ca",
  },

  {
    title: "Italian restaurant",
    skills: "JavaScript, React, Redux",
    img: pasta,
    link: "https://fanciful-sopapillas-f3d09f.netlify.app/",
  },

  {
    title: "Translator",
    skills: "JavaScript, React, Google Cloud API",
    img: translation,
    link: "https://intranslationapp.netlify.app/",
  },

  {
    title: "Days counter",
    skills: "JavaScript, HTML, CSS",
    img: newyear,
    link: "https://counterdays.netlify.app/",
  },

  {
    title: "Weather forecast",
    skills: "JavaScript, API, HTML, CSS",
    img: weather,
    link: "https://forecastnew.netlify.app/",
  },

  {
    title: "Recipe finder",
    skills: "JavaScript, API, HTML, CSS",
    img: recipe,
    link: "https://tourmaline-sorbet-f12aa1.netlify.app/",
  },

  {
    title: "Facts about cats",
    skills: "React, API, HTML, CSS",
    img: fact,
    link: "https://factsofcats.netlify.app/",
  },

  {
    title: "Furniture show room",
    skills: "JavaScript, HTML, CSS",
    img: shop,
    link: "https://furniture-salon-new.glitch.me/",
  },

  {
    title: "Relaxtion app",
    skills: "JavaScript, HTML, CSS",
    img: relax,
    link: "https://meditationday.netlify.app/",
  },

  {
    title: "Tip counter",
    skills: "JavaScript, HTML, CSS",
    img: tips,
    link: "https://calcoftips.netlify.app/",
  },
];

export { projects };
